import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Form, Col, Row, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MemberLocationDropdown from "../../form/MemberLocationDropdown";

import FormValidation from "../../form/validation/FormValidation";
import { UserContext } from "shared/context/UserContext";
import { GetISODate } from "../../../shared/helpers/DateHelpers";

export function TotalSalesForm(props) {
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(
        new Date(new Date().setDate(new Date().getDate() - 7))
    );
    const [dateType, setDateType] = useState("claimsDispense");
    const [paidAmountType, setPaidAmountType] = useState("promiseToPay");
    const [includeCopay, setIncludeCopay] = useState(false);
    const [omitIgnored, setOmitIgnored] = useState(false);
    const [includeClid2, setIncludeClid2] = useState(true);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const [isCheckDateParameterSelected, setIsCheckDateParameterSelected] = useState(false);
    
    const userContext = useContext(UserContext);

    const isOrganizationReconArchive =
    userContext && userContext.currentOrganization &&
    (userContext.currentOrganization.isReconArchive === true 
    || userContext.currentOrganization.isGroupContainsReconArchive === true) ? true : false;

    useEffect(() => {
        setLoaded(false);
    }, [
        userContext.locations,
        userContext.metricLocations,
        userContext.recLocations,
        userContext.isUnrestrictedEraPath,
    ]);

    useEffect(() => {
        if (!loaded && selectedLocations.length > 0) {
            setLoaded(true);
            submitForm();
        }
    }, [selectedLocations]);

    useEffect(() => {
        if (dateType === "checkDate") {
            setIsCheckDateParameterSelected(true);
            setPaidAmountType("remittancePaid");
            setIncludeCopay(false);
            setOmitIgnored(false);
        }
        else{
            setIsCheckDateParameterSelected(false);
        }
    }, [dateType]);


    function submitForm() {
        let parameters = {
            fromDate: fromDate,
            toDate: toDate,
            dateType: dateType,
            paidAmountType: paidAmountType,
            includeCopay: includeCopay,
            omitIgnored: omitIgnored,
            selectedLocations: selectedLocations,
            requiredFields: ["fromDate", "toDate"],
        };

        let validationIssueMessage = FormValidation(parameters);

        if (validationIssueMessage) {
            alert(validationIssueMessage);
        } else {
            // MPI-451: Always pass false per SME feedback (revert of NETX-5573)
            // let includeClid2Values = false;
            // if(isOrganizationReconArchive && dateType === "checkDate" && paidAmountType === "remittancePaid"){
            //     includeClid2Values = includeClid2;
            // }

            props.handleFormSubmit({
                toDate: GetISODate(toDate),
                fromDate: GetISODate(fromDate),
                dateType: dateType,
                paidAmountType: paidAmountType,
                includeCopay: includeCopay,
                omitIgnored: omitIgnored,
                selectedLocation: selectedLocations.join(","),
                includeClid2: false   // MPI-451: always false (was: includeClid2Values)
            });
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        submitForm();
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="justify-content-start">
                <Col md="auto" className="d-flex flex-column">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                        name="fromDate"
                        as={DatePicker}
                        selected={fromDate}
                        onChange={(date) => setFromDate(date)}
                    />
                </Col>
                <Col md="auto" className="d-flex flex-column">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                        name="toDate"
                        as={DatePicker}
                        selected={toDate}
                        onChange={(date) => setToDate(date)}
                    />
                </Col>
                <Col md="auto" className="d-flex flex-column">
                    <Form.Label>Location (NCPDP)</Form.Label>
                    <Form.Control
                        as={MemberLocationDropdown}
                        onChange={(locations) => setSelectedLocations(locations)}
                        programSubscription={"Rec2.0"}
                    />
                </Col>

                <Col md="auto" className="d-flex flex-column">
                    <Form.Label>Date Type</Form.Label>
                    <div key="dateType" className="mb-3 mr-2">
                        <Form.Check
                            custom="true"
                            type="radio"
                            id={`dateType${props._uid}-1`}
                            name="dateType"
                            onChange={(event) => setDateType(event.target.value)}
                            label="Claims Dispense"
                            value="claimsDispense"
                            checked={dateType === "claimsDispense"}
                        />
                        <Form.Check
                            custom="true"
                            type="radio"
                            id={`dateType${props._uid}-2`}
                            name="dateType"
                            onChange={(event) => setDateType(event.target.value)}
                            label="Claims Transaction"
                            value="claimsTransaction"
                            checked={dateType === "claimsTransaction"}
                        />
                        <Form.Check
                            custom="true"
                            type="radio"
                            id={`dateType${props._uid}-3`}
                            name="dateType"
                            onChange={(event) => setDateType(event.target.value)}
                            label="Check Date"
                            value="checkDate"
                            checked={dateType === "checkDate"}
                        />
                        {/*<Form.Check custom="true" type="radio" id={`dateType${props._uid}-4`} name="dateType" onChange={(event) => setDateType(event.target.value)} label="Check Payment" value="checkPayment" />*/}
                    </div>
                </Col>
                <Col md="auto" className="d-flex flex-column">
                    <Form.Label>Paid Amount Type</Form.Label>
                    <div key="PaidAmountType" className="mb-3 mr-2">
                        <Form.Check
                            custom="true"
                            type="radio"
                            id={`PaidAmountType${props._uid}-1`}
                            name="PaidAmountType"
                            onChange={(event) => setPaidAmountType(event.target.value)}
                            label="Promise to Pay"
                            value="promiseToPay"
                            checked={paidAmountType === "promiseToPay"}
                            disabled={isCheckDateParameterSelected}
                        />
                        <Form.Check
                            custom="true"
                            type="radio"
                            id={`PaidAmountType${props._uid}-2`}
                            name="PaidAmountType"
                            onChange={(event) => setPaidAmountType(event.target.value)}
                            label="Remittance Paid"
                            value="remittancePaid"
                            checked={paidAmountType === "remittancePaid"}
                        />
                    </div>
                </Col>
                <Col
                    as={Col}
                    md="auto"
                    className="d-flex flex-column"
                    controlid="TotalSalesByLocationControllers"
                >
                    <div key="TotalSalesByLocationControllers" className="mb-3 mt-3 pt-3">
                        <Form.Check
                            custom="true"
                            type="checkbox"
                            id={`IncludeCopay${props._uid}`}
                            name="includeCopay"
                            label="Include Copay Values"
                            onChange={(event) => setIncludeCopay(event.target.checked)}
                            disabled={isCheckDateParameterSelected}
                            checked={includeCopay}
                        />
                        <Form.Check
                            custom="true"
                            type="checkbox"
                            id={`OmitIgnored${props._uid}`}
                            name="omitIgnored"
                            label="Omit Ignored Claims"
                            onChange={(event) => setOmitIgnored(event.target.checked)}
                            disabled={isCheckDateParameterSelected}
                            checked={omitIgnored}
                        />
                        {/*
                        {isOrganizationReconArchive && dateType === "checkDate" && paidAmountType === "remittancePaid" ?
                        <Form.Check
                        type="checkbox"
                        label="Include Unarchived Checks"
                            onChange={(event) => setIncludeClid2(event.target.checked)}
                        checked={includeClid2}
                        /> : null}
                        */}
                    </div>
                </Col>

                <Col md="auto" className="d-flex flex-column">
                    <Button className="inline-show-result-button" size="sm" type="submit">
                        Show Results
                    </Button>
                </Col>
            </Row>
        </Form>
    );
}

TotalSalesForm.propTypes = {
    handleFormSubmit: PropTypes.func.isRequired,
};
